// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nE70","fullView":"styles_fullView__2pm64"};